import React, { Component } from 'react';
import './Resume.css'; 

class Resume extends Component {
  render() {
    
    //resume svg paths. 
    const resumePages = [
      process.env.PUBLIC_URL + '/Sreehari-Resume/page_1.svg',
      process.env.PUBLIC_URL + '/Sreehari-Resume/page_2.svg',
      process.env.PUBLIC_URL + '/Sreehari-Resume/page_3.svg',
    ];

    return (
      <div className="resume-container">
        <div className="resume-header">
          <h1>Resume</h1>
        </div>
        
        <div className="resume-pages">
          {resumePages.map((pagePath, index) => (
            <div key={index} className="resume-page">
              <img 
                src={pagePath} 
                alt={`Resume page ${index + 1}`}
                className="resume-svg"
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Resume;